export const localStorageGetter = (item: string) =>
  localStorage.getItem(item) || '';

export const localStorageSetter = (item: string, data: string) =>
  localStorage.setItem(item, data);
